module.exports = __webpack_public_path__ + "img/yishi12.90518c58.jpg";